import React from 'react';
import './NewsItem.css';
import authorIcon from "../../img/author.svg";
import timeIcon from "../../img/clock.svg";

class NewsItem extends React.Component {
    render() {
        return (
            <div className="news">
                <div className="news-title"><a href={this.props.url}>{this.props.title}</a></div>
                <div className="news-statistic">
                    <div className="views"><img className="news-img" alt="author" src={authorIcon}/><span>{this.props.author}</span></div>
                    <div className="time"><img alt="time" src={timeIcon}/><span>{this.props.publicDate}</span></div>
                </div>
            </div>
        )
    }
}

export default NewsItem;